<template>
  <div id="App">
    <Logo></Logo>
    <van-row gutter="20">
      <van-col span="2"></van-col>
      <van-col span="20">
        <van-form @submit="onSubmit">
          <van-field
            v-model="userInfo.userCardID"
            :name="zh"
            :label="zh"
            :placeholder="zh"
            :rules="[{ required: true, message: '请填写' + zh }]"
          />
          <van-field
            v-model="userInfo.userName"
            :name="mm"
            :label="mm"
            :placeholder="mm"
            :type="userInfo.loginType == '3' || userInfo.loginType == '4' ? 'password' : 'text'"
            :rules="[{ required: true, message: '请填写' + mm }]"
          />
          <van-field name="radioLoginType" label="类型">
            <template #input>
              <van-radio-group v-model="userInfo.loginType" @change="changeLoginType" direction="horizontal">
                <van-radio name="0" style="margin-bottom: 5px">建筑工人</van-radio>
                <van-radio name="1" style="margin-bottom: 5px">班组长</van-radio>
                <van-radio name="2" style="margin-bottom: 5px">项目管理员</van-radio>
                <van-radio name="3" style="margin-bottom: 5px">企业管理员</van-radio>
                <van-radio name="4" style="margin-bottom: 5px">运维人员</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div style="margin: 16px">
            <van-button round block type="info" native-type="submit">
              登录
            </van-button>
          </div>
        </van-form>
      </van-col>
      <van-col span="2"></van-col>
    </van-row>
    <van-overlay :show="show">
      <div class="wrapper">
        <van-loading color="#1989fa"/>
      </div>
    </van-overlay>
  </div>
</template>

<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>

<script>
import { mapState } from 'vuex'
import Logo from '../components/Logo.vue'
import { Dialog } from 'vant';
export default {
  data () {
    return {
        userInfo: {
            userName: '',
            userCardID: '',
            loginType: '0',
            token: '',
            wechatUserCode: '',
        },
        show:false ,
        zh:"身份证号" ,
        mm:"姓名" ,
    }
  },
  computed: {
    ...mapState(['weChatAppId','weChatUrl'])
  },
  created: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {  // 微信浏览器下
        if (typeof this.$route.query.code === "undefined") { 
          window.location.href = `${`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.weChatAppId}&redirect_uri=${encodeURI(
            this.weChatUrl
          )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`}`;
        }
        else
        {
          this.show = true
          var that = this
          that.$axios.get('/api/WeChat' ,
          {
              params:{
                  code : that.$route.query.code,
              } 
          })
          .then(response => {
            if(response.data.userCardID != "")
            {
              that.userInfo.loginType = response.data.loginType
              that.userInfo.wechatUserCode = response.data.wechatUserCode
              that.userInfo.userName = response.data.userName
              that.userInfo.userCardID = response.data.userCardID
              that.userInfo.token = response.data.token
              that.$store.commit('setUserInfo', that.userInfo)
              that.$router.push('/selprolist')
            }
            else
            {
              that.userInfo.wechatUserCode = response.data.wechatUserCode
            }
            that.show = false;
          })
          .catch(error => {
              that.show = false;
              console.log(error);
              //弹出失败提醒
              // Dialog({ message: error.message })
          })
        }
    }
  },
  components: {
    Logo
  },
  methods: {
    changeLoginType(){
      if(this.userInfo.loginType == '3' || this.userInfo.loginType == '4')
      {
        this.zh = '账号'
        this.mm = '密码'
      }
      else
      {
        this.zh = '身份证号'
        this.mm = '姓名'
      }
    },
    onSubmit () {
      var that = this
      that.$axios.get('/api/Auth' ,
      {
          params:{
              userName : that.userInfo.userName,
              pwd : that.userInfo.userCardID,
              loginType: that.userInfo.loginType,
              wechatUserCode: that.userInfo.wechatUserCode
          } 
      })
      .then(response => {
          if(response.data.status == "200")
          {
            that.userInfo.token = response.data.token
            that.$store.commit('setUserInfo', that.userInfo)
            that.$router.push('/selprolist')
          }
          else
          {
            console.log(response.data.msg);
            Dialog({ message: response.data.msg })
          }
      })
      .catch(error => {
          console.log(error);
          //弹出失败提醒
          // Dialog({ message: error.message })
      })
    }
  }
}
</script>
